export default "__VITE_ASSET__jrvWh$am__"